import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  ComponentRef,
  Injector,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewContainerRef,
} from '@angular/core';
import { EmptyListPlaceholderComponent } from './empty-list-placeholder/empty-list-placeholder.component';

@Directive({
  selector: '[showPlaceholderIf]',
  standalone: false,
})
export class ShowPlaceholderIfDirective implements OnChanges {
  @Input() showPlaceholderIf = false;
  @Input() labelText = 'global.no_items';
  @Input() btnText = '';

  @Output() btnClick = new EventEmitter<void>();

  private componentRef: ComponentRef<EmptyListPlaceholderComponent> | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private injector: Injector,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.updateView();
  }

  private updateView() {
    const showPlaceholder = this.showPlaceholderIf;

    if (showPlaceholder) {
      this.hideOriginalContent();
      this.insertPlaceholder();
    } else {
      this.showOriginalContent();
    }
  }

  private showOriginalContent() {
    this.renderer.setStyle(this.el?.nativeElement, 'display', '');
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }

  private hideOriginalContent() {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
  }

  private insertPlaceholder() {
    if (!this.componentRef) {
      this.componentRef = this.viewContainerRef.createComponent(EmptyListPlaceholderComponent, {
        injector: this.injector,
      });
      this.componentRef.instance.labelText = this.labelText;
      this.componentRef.instance.btnText = this.btnText;

      this.componentRef.instance.btnClick.subscribe(() => {
        this.btnClick.emit();
      });
    }
  }
}
